import { Text } from '@react-pdf/renderer';
import React, { FC } from 'react';
import { BadgeStyle } from '../../../../types/badge';

type Props = {
  text: string;
} & BadgeStyle;

export const BadgeText: FC<Props> = ({ style, text }) => {
  return <Text style={style}>{text}</Text>;
};
